import styled from '@emotion/styled'

export const OnlyMobileTablet = styled.div`
  @media (min-width: 992px) {
    display: none;
  }
`

export const Container = styled.div`
  width: 100%;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
`

export const Row = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const Item = styled.div`
  flex: 0 0 auto;
`

export const ItemLink = styled.a`
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 12px;
  border-radius: 999px;
  text-decoration: none;
  font-size: 14px;
  white-space: nowrap;

  border: 1px solid rgba(0, 0, 0, 0.12);

  [data-active='true'] & {
    border-color: rgba(65, 160, 23, 0.55);
    background: rgba(65, 160, 23, 0.08);
  }
`

export const SkeletonRow = styled.div`
  width: 100%;
  padding: 12px 16px;
  display: flex;
  gap: 8px;
  overflow: hidden;
`

export const SkeletonPill = styled.div`
  width: 110px;
  height: 36px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.06);
`
